import { createBrowserRouter, RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { coreRoutes } from '@core/core.routes.tsx';
import { authRoutes } from '@modules/auth/auth.routes.tsx';
import { appBuilderWebRoutes } from '@modules/app-builder/web/app-builder-web.routes.tsx';
import { RoutePaths } from '@utils/route.utils.ts';
import AuthGuard from '@guards/auth.guard.tsx';
import BlockAuthenticatedAccessGuard from '@guards/block-authenticated-access.guard.tsx';
import WebModeGuard from '@guards/web-mode.guard.tsx';
import { ErrorFallback } from '@components/error-boundary';

const CoreComponent = lazy(() => import('@core/core.tsx'));
const AuthComponent = lazy(() => import('@modules/auth/auth.tsx'));
const VerifyBeforePasswordChangeComponent = lazy(
  () =>
    import(
      '@modules/verify-before-password-change/verify-before-password-change.tsx'
    )
);
const ChangePasswordComponent = lazy(
  () => import('@modules/change-password/change-password.tsx')
);
const AppBuilderWebComponent = lazy(
  () => import('@modules/app-builder/web/app-builder-web.tsx')
);

export const routes: RouteObject[] = [
  {
    path: RoutePaths.Auth.path,
    element: (
      <Suspense>
        <BlockAuthenticatedAccessGuard>
          <AuthComponent />
        </BlockAuthenticatedAccessGuard>
      </Suspense>
    ),
    children: [...authRoutes],
    errorElement: <ErrorFallback />
  },
  {
    path: RoutePaths.AppBuilderWeb.path,
    element: (
      <Suspense>
        <WebModeGuard>
          <AppBuilderWebComponent />
        </WebModeGuard>
      </Suspense>
    ),
    children: [...appBuilderWebRoutes],
    errorElement: <ErrorFallback />
  },
  {
    path: RoutePaths.VerifyBeforePasswordChange.path,
    element: (
      <Suspense>
        <VerifyBeforePasswordChangeComponent />
      </Suspense>
    ),
    errorElement: <ErrorFallback />
  },
  {
    path: RoutePaths.ChangePassword.path,
    element: (
      <Suspense>
        <ChangePasswordComponent />
      </Suspense>
    ),
    errorElement: <ErrorFallback />
  },
  {
    path: '',
    element: (
      <Suspense>
        <AuthGuard>
          <CoreComponent />
        </AuthGuard>
      </Suspense>
    ),
    children: [...coreRoutes],
    errorElement: <ErrorFallback />
  }
];

const router = createBrowserRouter(routes);

export default router;
